import {
  RECEIPT_TEMPLATES_DATA,
  RECEIPT_TEMPLATES_LOADING,
  RECEIPT_TEMPLATES_UPDATED,
  STORE_USERS_CHANGE,
  DEFAULT_LABEL_PRINT_FORMAT,
  DEFAULT_SKU_GENERATION,
  TRACK_BOX_COLOR,
  TRACK_ROW_COLOR,
  INV_ADJ_MOV
} from '../../constants/ActionTypes'

const initialSettings = {
  receiptTemplatesData: [],
  isReceiptTemplateUpdated: false,
  isReceiptTemplateLoading: true,
  storeUsersList: [],
  storeUsersChange: true,
  defaultLabelPrintFormat: '1',
  defaultSKUGeneration: '1',
  trackBoxColor: 'order-placed',
  trackRowColor: '',
  invAdjMovement: []
}

const Setup = (state = initialSettings, action) => {
  switch (action.type) {
    //**********CASH_MANAGEMENT************
    case RECEIPT_TEMPLATES_DATA:
      return {
        ...state,
        receiptTemplatesData: action.payload
      }
    case RECEIPT_TEMPLATES_LOADING:
      return {
        ...state,
        isReceiptTemplateLoading: action.payload
      }
    case RECEIPT_TEMPLATES_UPDATED:
      return {
        ...state,
        isReceiptTemplateUpdated: action.payload
      }
    case STORE_USERS_CHANGE:
      return {
        ...state,
        storeUsersChange: action.payload
      }
    case DEFAULT_LABEL_PRINT_FORMAT:
      return {
        ...state,
        defaultLabelPrintFormat: action.payload
      }
    case DEFAULT_SKU_GENERATION:
      return {
        ...state,
        defaultSKUGeneration: action.payload
      }
    case TRACK_BOX_COLOR:
      return {
        ...state,
        trackBoxColor: action.payload
      }
    case TRACK_ROW_COLOR:
      return {
        ...state,
        trackRowColor: action.payload
      }
    case INV_ADJ_MOV:
      return {
        ...state,
        invAdjMovement: action.payload
      }

    default:
      return state
  }
}

export default Setup
